import React from "react";
import { BlogLayout } from "@/components/layout/BlogLayout";
import { TableOfContents } from "@/components/blog/TableOfContents";
import { PostHeader } from "@/components/blog/PostHeader";
import { PostIntroSection } from "@/components/blog/PostIntroSection";
import { aiOverviewsSeoTableOfContents } from "./ai-overviews-seo/tableOfContents";
import { ArticleContent } from "./ai-overviews-seo/ArticleContent";
import { RelatedArticles } from "@/components/blog/RelatedArticles";
import { Breadcrumbs } from "@/components/shared/Breadcrumbs";
import { UpdateDate } from "@/components/shared/UpdateDate";
import aiOverviewsImage from "@/assets/blog-ai-overviews-seo.jpg";

export function AiOverviewsSeoPost() {
  return (
    <>
      <PostHeader 
        title="Google AI Overviews: Impacto en el SEO y cómo adaptarse en 2026 | SEOEVOLUTION"
        description="Descubre cómo los AI Overviews de Google están redistribuyendo el tráfico orgánico en 2026, qué sectores son los más afectados y las estrategias clave para ser citado por la IA."
        keywords="AI Overviews, Google IA, SEO 2026, GEO, optimización motores generativos, tráfico orgánico, citaciones IA"
        author="Ángel Ruz"
        canonicalUrl="https://agenciaseoevolution.com/blog/google-ai-overviews-seo-2026"
      />

      <BlogLayout>
        <article className="py-16 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-seo-darkBlue to-seo-dark opacity-90"></div>
          <div className="container mx-auto px-4 md:px-6 relative z-10">
            <div className="max-w-5xl mx-auto">
              <Breadcrumbs />
              
              <PostIntroSection 
                category="SEO E INTELIGENCIA ARTIFICIAL"
                title="Google AI Overviews: Impacto en el SEO y cómo adaptarse en 2026"
                date="11 Abril, 2026"
                author="Ángel Ruz"
                imageUrl={aiOverviewsImage}
                imageAlt="Google AI Overviews: cómo afectan al SEO en 2026"
                description="Google ya no es solo un buscador de enlaces: es un motor de respuestas impulsado por IA. Los AI Overviews están redistribuyendo el tráfico orgánico, creando ganadores y perdedores. Las fuentes citadas ganan hasta un 40% más de clics, mientras que las posiciones medias no citadas pierden hasta un 25%. En este artículo analizamos los datos reales, el impacto por sector y las estrategias para convertir tu web en una fuente que Google cite."
              />

              <UpdateDate 
                date="Abril 2026"
                updatesSection={
                  <div>
                    <p className="font-semibold mb-2">Datos actualizados abril 2026:</p>
                    <ul className="list-disc list-inside space-y-1 text-sm">
                      <li>30-35% de búsquedas muestran AI Overviews</li>
                      <li>Fuentes citadas ganan 20-40% más CTR</li>
                      <li>El GEO emerge como disciplina complementaria al SEO</li>
                      <li>Expansión hacia consultas transaccionales prevista para 2027</li>
                    </ul>
                  </div>
                }
              />

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2 bg-seo-dark/50 rounded-xl p-6 shadow-lg backdrop-blur-xs">
                  <ArticleContent />
                  <RelatedArticles currentSlug="/google-ai-overviews-seo-2026" category="SEO Inteligente" />
                </div>
                
                <div className="lg:col-span-1">
                  <TableOfContents items={aiOverviewsSeoTableOfContents} />
                </div>
              </div>
            </div>
          </div>
        </article>
      </BlogLayout>
    </>
  );
}
